<template>
  <div class="AppBulkListItem d-flex align-center column-gap-2 text--bold">
    <slot />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'AppBulkListItem',
})
</script>

<style scoped lang="scss">
@import "@/scss/border-tokens";

.AppBulkListItem {
  background-color: rgb(var(--v-theme-grey-25));
  @include border-radius('border-radius-3');
  border: get-border();
  min-height: 52px;
  padding: 8px 16px;
}
</style>
